import React from 'react';
import { link_config } from '../../const';
import './index.less';

const concat_config = {
  zh_title: '联系我们',
  en_title: 'Contact Us'
};
export default function Index(props) {
  return (
    <div className='base-bottom-right'>
      <div className='base-bottom-right-contact-title'>{concat_config[`${props.language}title`]}</div>
      {
        link_config.map((item, index) => {
          return <div className='base-bottom-right-link' key={index}>
            <span>{item[`${props.language}title`]}</span>
            <span>:{item.detail}</span>
          </div>;
        })
      }
    </div>
  );
}
